import { SubscriptionFormVisibleContext } from '@contexts/subscription-form-visible'
import { ModalUI } from '@ui/modal/modal'
import { graphql } from 'gatsby'
import React, { useCallback, useContext } from 'react'

import { SubscriptionForm } from './subscription-form'

const Form: Utils.EntryFC<Queries.ContentfulFormFragment> = ({ content }) => {
  const { open, isOpen } = useContext(SubscriptionFormVisibleContext)
  const { titreFormulaire, ...restContent } = content

  const onCloseClick = useCallback(() => {
    open(false)
  }, [])

  return (
    <div>
      <div className="hidden laptop:block">
        <SubscriptionForm content={content} />
      </div>
      <div className="block laptop:hidden">
        <ModalUI
          fullScreen
          modalTitle={titreFormulaire}
          visible={isOpen}
          onClose={onCloseClick}
        >
          <SubscriptionForm content={restContent} />
        </ModalUI>
      </div>
    </div>
  )
}

export const query = graphql`
  fragment ContentfulForm on ContentfulLandingSouscriptionMarqueBlancheV2 {
    ...ContentfulEntry
    titreFormulaire
    codePromo
    individualOnly
    partnerName
    vpDefaultSavings
    mandatoryMemberID
  }
`

export default Form
